export default __webpack_public_path__ + "static/personal_2-ee8e4d29e8f54bacc86229850e529e6e.jpg";